import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { uniqueId } from 'lodash';
import { Box, Flex, Text } from 'core/components';
import { generatorMap } from 'app/util/tagging/tagEngine';
import { getOrdinalSuffix } from 'app/util/utils';
import { formConsumer } from 'core/form';

@inject('$explorer', '$dictionary')
@formConsumer
@observer
export default class PercentileRangesDisplay extends Component {
  render() {
    const { form } = this.props;
    const fieldValue = form.getValue('bracketOptions');
    const bracketType = fieldValue ? fieldValue.type : 'N/A';
    const isPercentile = bracketType === 'percentiles';
    const displayName = generatorMap[bracketType] ? generatorMap[bracketType].display : 'N/A';

    const ranges = fieldValue.ranges.map((range, index, array) => {
      const rangeValue = range.to;
      const previousRangeValue = index !== 0 ? array[index - 1].to : 0;

      return (
        <div
          key={uniqueId()}
          style={{ minWidth: '30px', flex: `1 ${rangeValue - previousRangeValue}%`, borderRight: '1px solid' }}
        >
          <Text as="div" ellipsis small style={{ textAlign: 'right', paddingRight: '2px' }}>
            {rangeValue}
            {isPercentile ? getOrdinalSuffix(+rangeValue) : '%'}
          </Text>
          <Text as="div" style={{ height: '20px', backgroundColor: range.data.value }} />
        </div>
      );
    });

    ranges.push(
      <div
        key={uniqueId()}
        style={{
          minWidth: '30px',
          flex: `1 ${100 - fieldValue.ranges[fieldValue.ranges.length - 1].to}%`
        }}
      >
        <Text as="div" small ellipsis style={{ textAlign: 'right', paddingRight: '2px' }}>
          &nbsp;
        </Text>
        <div style={{ height: '20px', backgroundColor: fieldValue.over }} />
      </div>
    );

    return (
      <Flex flexDirection="column">
        <Box flex={1} mb={1}>
          <Text small>{displayName}:</Text>
        </Box>
        <Flex>{ranges}</Flex>
      </Flex>
    );
  }
}
